import { stat } from "fs";

const permission = {
  state: {
    data: []
  },
  mutations: {
    SET_PERMISSION: (state, permission) => {
      state.data = permission
    }
  }
}

export default permission


// WEBPACK FOOTER //
// ./src/store/modules/permission.js